/*
 * SelectConstants
 */

export const UPDATE_OPTION = 'ideal/Select/UPDATE_OPTION';
export const UPDATE_MODAL_OPTION = 'ideal/Select/UPDATE_MODAL_OPTION';

